<template>
  <el-form-item
    :label="label"
    class="remarks"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="remarks"
      type="textarea"
      :clearable="true"
      :maxlength="300"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '備考'
    },
    prop: {
      type: String,
      default: 'remarks'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: '最大300文字'
    }
  },
  computed: {
    remarks: {
      get () {
        return this.value
      },
      set (remarks) {
        this.$emit('input', remarks)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
